import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const isActive = (path: string) => {
    return location.pathname.includes(path);
  };

  const navigationSections = [
    {
      title: 'Overview',
      items: [
        { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
        { path: '/admin/analytics', label: 'Warranty Analytics', icon: '📈' }
      ]
    },
    {
      title: 'System Monitoring',
      items: [
        { path: '/admin/system-health', label: 'System Health', icon: '🩺' },
        { path: '/admin/uptime', label: 'Uptime Monitor', icon: '⏱️' }
      ]
    },
    {
      title: 'Administration',
      items: [
        { path: '#', label: 'User Management', icon: '👥' },
        { path: '#', label: 'Settings', icon: '⚙️' },
        { path: '#', label: 'Audit Logs', icon: '📋' }
      ]
    }
  ];

  return (
    <div className="admin-main-layout">
      {/* Mobile Menu Button */}
      <button 
        className="admin-mobile-menu-btn"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        style={{
          position: 'fixed',
          top: '1rem',
          left: '1rem',
          zIndex: 1001,
          display: 'none',
          padding: '0.5rem',
          backgroundColor: 'var(--admin-primary)',
          color: 'white',
          border: 'none',
          borderRadius: 'var(--admin-border-radius-sm)',
          fontSize: '1.2rem',
          cursor: 'pointer'
        }}
      >
        {sidebarOpen ? '✕' : '☰'}
      </button>

      {/* Sidebar */}
      <nav className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        {/* Sidebar Header */}
        <div className="admin-sidebar-header">
          <Link to="/admin/dashboard" className="admin-sidebar-brand">
            <div className="admin-sidebar-logo">S</div>
            <div>
              <h1 className="admin-sidebar-title">Suvadi</h1>
              <p className="admin-sidebar-subtitle">Admin Portal</p>
            </div>
          </Link>
        </div>

        {/* Navigation */}
        <div className="admin-sidebar-nav">
          {navigationSections.map((section, sectionIndex) => (
            <div key={sectionIndex} className="admin-nav-section">
              <div className="admin-nav-section-title">{section.title}</div>
              {section.items.map((item, itemIndex) => (
                <Link
                  key={itemIndex}
                  to={item.path}
                  className={`admin-nav-item ${isActive(item.path) ? 'active' : ''}`}
                  onClick={item.path === '#' ? (e) => e.preventDefault() : undefined}
                >
                  <span className="admin-nav-icon">{item.icon}</span>
                  {item.label}
                  {item.path === '#' && (
                    <div className="admin-dummy-badge admin-badge" style={{ marginLeft: 'auto', fontSize: '0.65rem' }}>
                      DUMMY
                    </div>
                  )}
                </Link>
              ))}
            </div>
          ))}
        </div>

        {/* Sidebar Footer */}
        <div style={{ 
          position: 'absolute', 
          bottom: 0, 
          left: 0, 
          right: 0, 
          padding: 'var(--admin-spacing-lg)', 
          borderTop: '1px solid var(--admin-gray-800)',
          background: 'var(--admin-gray-900)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--admin-spacing-sm)', marginBottom: 'var(--admin-spacing-sm)' }}>
            <div className="admin-badge success" style={{ fontSize: '0.7rem' }}>
              <span className="admin-badge-dot"></span>
              Real Data
            </div>
            <div className="admin-badge info" style={{ fontSize: '0.7rem' }}>
              Live System
            </div>
          </div>
          <div style={{ fontSize: 'var(--admin-font-size-xs)', color: 'var(--admin-gray-400)' }}>
            Backend: Connected to H2 Database
          </div>
        </div>
      </nav>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div 
          className="admin-mobile-overlay"
          onClick={() => setSidebarOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
            display: 'none'
          }}
        />
      )}

      {/* Main Content */}
      <main className="admin-content">
        <div className="admin-content-inner">
          {children}
        </div>
      </main>
    </div>
  );
};
